import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Sparkles } from "lucide-react";
import { API } from "../../App";
import { useAdminAuth } from "./AdminLayout";
import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";
import { Switch } from "../../components/ui/switch";

export const FoundingPromoCard = () => {
  const { token } = useAdminAuth();
  const [state, setState] = useState(null);
  const [busy, setBusy] = useState(false);
  const headers = { Authorization: `Bearer ${token}` };

  useEffect(() => {
    axios.get(`${API}/admin/founding-promo`, { headers }).then((r) => setState(r.data)).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const toggle = async (open) => {
    setBusy(true);
    try {
      const r = await axios.put(`${API}/admin/founding-promo`, { open }, { headers });
      setState(r.data);
      toast.success(open ? "Founding enrollment reopened" : "Founding enrollment closed");
    } catch {
      toast.error("Could not update the promotion");
    } finally {
      setBusy(false);
    }
  };

  if (!state) return null;
  return (
    <Card data-testid="founding-promo-card">
      <CardHeader className="pb-2">
        <CardTitle className="flex items-center gap-2 text-lg"><Sparkles className="h-5 w-5 text-gold" /> Founding Member Promotion</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-wrap items-center justify-between gap-4">
        <div className="text-sm text-muted-foreground" data-testid="founding-promo-status">
          {state.open
            ? "Open: new sign-ups get $5.99/month for life."
            : "Closed: new sign-ups pay $9.99/month. Visitors see “Founding Member enrollment is now closed.”"}
          <p className="mt-1 text-xs">{state.founders} founding members keep $5.99/month for life, even if they cancel and come back.</p>
        </div>
        <Switch checked={state.open} disabled={busy} onCheckedChange={toggle} className="data-[state=unchecked]:bg-slate-400" aria-label="Founding enrollment open" data-testid="founding-promo-switch" />
      </CardContent>
    </Card>
  );
};
